import { Device } from "@fairfleet/geotab";
import { normalizeSearchText } from "@/utilities/text/normalizeSearchText";

/**
 * The vehicles whose name, plate, VIN or serial number contain every word of `search`, best
 * first: a name that starts with the search before one that only contains it, then by name.
 *
 * Searches what the map has already loaded instead of asking Geotab, which for a search of up to
 * three characters ignored the text and answered with the first 1000 vehicles.
 */
export function searchDevices(devices: Iterable<Device>, search: string, limit: number): Device[] {
  const words = normalizeSearchText(search).split(/\s+/).filter(Boolean);
  const matches: { device: Device; name: string; startsWith: boolean }[] = [];

  for (const device of devices) {
    const name = normalizeSearchText(device.name);
    const haystack = [name, device.licensePlate, device.vehicleIdentificationNumber, device.serialNumber]
      .map(value => normalizeSearchText(value))
      .join(" ");
    if (words.every(word => haystack.includes(word))) {
      matches.push({ device, name, startsWith: words.length > 0 && name.startsWith(words[0]) });
    }
  }

  matches.sort((a, b) => Number(b.startsWith) - Number(a.startsWith) || a.name.localeCompare(b.name));
  return matches.slice(0, limit).map(match => match.device);
}
